export default __webpack_public_path__ + "static/vi-testimonial-bg-desktop-dark-d76d4ce4c189d821d1f6dc0cf3b25ea6.png";